<template>
  <StoreCartSection title="">
    <div class="p-4 dark:bg-gray-900 dark:text-gray-300">
      <table class="price-summary">
        <tbody>
          <tr>
            <td>{{ $t("subtotal") }}</td>
            <td>
              <Amount :value="subTotal" />
            </td>
          </tr>
          <tr v-if="discountAmount">
            <td>Discount</td>
            <td>
              <Amount is-negetive :value="discountAmount" />
            </td>
          </tr>
          <tr v-if="appliedCoupon && appliedCoupon.code">
            <td>
              <p>{{ $t("coupon_discount") }}</p>
            </td>
            <td>
              <Amount is-negetive :value="appliedCoupon.discountedAmount" />
            </td>
          </tr>
          <tr>
            <td>{{ $t("addon_charges") }}</td>
            <td>
              <Amount :value="checkoutAddonCharge" />
            </td>
          </tr>
          <tr>
            <td>{{ $t("delivery_charge") }}</td>
            <td>
              <Amount :value="deliveryCharge" />
            </td>
          </tr>
          <tr>
            <td>{{ $t("taxes_and_charges") }}</td>
            <td>
              <Amount :value="charges" />
            </td>
          </tr>
          <tr v-if="adjustment">
            <td>Adjustment</td>
            <td>
              <Amount :value="adjustment" />
            </td>
          </tr>
          <tr v-if="total">
            <td>{{ $t("total") }}</td>
            <td>
              <Amount class="font-bold" :value="total" />
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </StoreCartSection>
</template>

<script>
import { mapState } from "pinia";
import { useProductStore } from "@/store/product";

export default {
  props: {
    subTotal: { type: Number, default: null },
    charges: { type: Number, default: null },
    deliveryCharge: { type: Number, default: null },
    total: { type: Number, default: null },
    appliedCoupon: { type: Object, default: null },
    discountAmount: { type: Number, default: null },
    adjustment: { type: Number, default: null },
    checkoutAddonCharge: { type: Number, default: null },
  },
  computed: {
    ...mapState(useProductStore, ["productPriceDisplay"]),
  },
};
</script>

<style>
.price-summary {
  width: 100%;

  td {
    @apply text-sm py-1;

    &:nth-child(2) {
      @apply text-end font-medium;
    }
  }
}
</style>
